import Vue from "vue";
import VueRouter from "vue-router";
import GameOverView from "../views/GameOverView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: GameOverView,
  },
  {
    path: "/mentions",
    name: "mentions",
    component: GameOverView,
  },
  {
    path: "/admin/airport/toulouse/blagnac/agency/checkcode/control",
    name: "admin",
    component: GameOverView,
    meta: { requiresAuth: true },
  },
  {
    path: "/form",
    name: "form",
    component: GameOverView,
  },
  {
    path: "/done",
    name: "done",
    component: GameOverView,
  },
  {
    path: "/contact",
    name: "contact",
    component: GameOverView,
  },
  {
    path: "/gameover",
    name: "gameover",
    component: GameOverView,
  },
  {
    path: "*",
    redirect: "/gameover"
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(/* to, from, savedPosition */) {
    // Toujours faire défiler vers le haut lors d'un changement de route
    return { x: 0, y: 0 };
  },
});

export default router;
